import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { TextAreaField } from "../formElements/TextAreaField";

const DraftModal = ({
  show,
  onHide,
  type = "document",
  formData = {},
  title = "Save as Draft",
  onConfirm,
  onDiscard,
  loading = false,
}) => {
  const [draftRemark, setDraftRemark] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (show) {
      setErrorMsg("");
    } else {
      setDraftRemark("");
      setErrorMsg("");
    }
  }, [show]);

  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setDraftRemark(value);

    if (errorMsg && value.trim()) {
      setErrorMsg("");
    }
  };

  const handleClose = () => {
    if (loading) return;
    onHide?.();
  };

  const handleDiscard = () => {
    if (loading) return;
    setDraftRemark("");
    setErrorMsg("");
    onDiscard?.();
  };

  const handleSubmit = async () => {
    const trimmedRemark = draftRemark.trim();

    if (!trimmedRemark) {
      setErrorMsg("Please enter remarks.");
      return;
    }

    const payload = {
      ...formData,
      module: type,
      status: "Draft",
      headerStatus: "Draft",
      draftRemark: trimmedRemark,
    };

    try {
      await onConfirm?.(payload);
    } catch (error) {
      console.error("Draft save failed:", error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>
          <i className="bi bi-save2 me-2"></i>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-4">
        <Row>
          <Col xs={12}>
            <p className="mb-3" style={{ fontSize: "16px", fontWeight: 500 }}>
              You have unsaved changes in {type?.toUpperCase()}. Do you want to
              save them as a draft before leaving?
            </p>

            <TextAreaField
              className="inputBox"
              name="draftRemark"
              id="draftRemark"
              label="Remarks"
              placeholder={`Enter ${type?.toLowerCase()} draft remarks`}
              value={draftRemark}
              onChange={handleRemarkChange}
              error={errorMsg}
              disabled={loading}
            />

            {errorMsg && (
              <p className="mt-2 mb-0 text-danger" style={{ fontSize: "14px" }}>
                {errorMsg}
              </p>
            )}
          </Col>
        </Row>

        <Row className="mt-4">
          <Col xs={12} className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDiscard}
              disabled={loading}
            >
              Discard
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Draft"}
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default DraftModal;